import axios from 'src/store/vue-axios/axios.js'

export default class Core {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // FIND-SCHOOLS -> /find-schools
  static findSchoolsUrl = () => '/find-schools'

  // LOGOUT-ALL -> /logout-all
  static logoutAllUrl = () => '/logout-all'

  // LOGOUT -> /logout
  static logoutUrl = () => '/logout'

  // APPLICATIONS/APPPLY -> /applications/apply
  static applicationsApplyUrl = () => '/applications/apply'

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // FIND-SCHOOLS -> /find-schools
  static async getFindSchools (config) {
    return axios.get(this.findSchoolsUrl(), config)
  }

  // LOGOUT-ALL -> /logout-all
  static async postLogoutAll () {
    return axios.post(this.logoutAllUrl())
  }

  // LOGOUT -> /logout
  static async postLogout (payload, config) {
    return axios.post(this.logoutUrl(), payload, config)
  }

  // APPLICATIONS/APPPLY -> /applications/apply
  static async postApplicationsApply (payload) {
    return axios.post(this.applicationsApplyUrl(), payload)
  }
}
